'use es6';

import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import DashedLabel from '../../atoms/DashedLabel';
import { getSubmittedTranscriptEmailAddress, getSubmittedTranscriptSubject } from 'conversations-message-history/transcript-submission/operators/messageOptionGetters';
import { getVerboseDateText } from 'conversations-message-history/util/getVerboseDateText';
import { getTimestamp } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { jsx as _jsx } from "react/jsx-runtime";
const TranscriptSubmission = ({
  message
}) => {
  return /*#__PURE__*/_jsx(DashedLabel, {
    transparent: true,
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'conversations-inbox-message-history.transcript-submission.description',
      options: {
        email: getSubmittedTranscriptEmailAddress(message),
        subject: getSubmittedTranscriptSubject(message),
        dateString: getVerboseDateText(getTimestamp(message))
      }
    })
  });
};
TranscriptSubmission.displayName = 'TranscriptSubmission';
TranscriptSubmission.propTypes = {
  message: RecordPropType('TranscriptSubmissionMessage').isRequired
};
export default TranscriptSubmission;